<template>
  <v-container
    id="productTemplateEdit"
    class="pa-0"
  >
    <div
      v-if="!productTypeId"
      class="text-center display-1"
    >
      Choose a Product Type
    </div>
    <div
      v-if="productTypeId && productTemplateType === 'Standard'"
      class="text-center display-1"
    >
      Standard Template
    </div>
    <div
      v-if="productTypeId && productTemplateType === 'Custom'"
      class="text-center display-1"
    >
      Custom Template
    </div>
    <v-row>
      <v-col
        cols="12"
      >
        <base-resource-select
          label="Type"
          item-text="productType"
          item-value="id"
          bind-text="productType"
          bind-value="productTypeId"
          :bind-item="editedItem"
          :error-messages="safeFormErrors.ProductTypeId"
          :resource="productTypeResource"
          @populated="productTypePopulated"
          @change="productTypeChanged"
        />
      </v-col>
    </v-row>
    <div
      v-if="productTypeId"
    >
      <v-row>
        <v-col
          cols="12"
        >
          <base-resource-select
            label="Platform"
            item-text="platform"
            item-value="id"
            bind-text="platform"
            bind-value="platformId"
            :bind-item="editedItem"
            :error-messages="safeFormErrors.PlatformId"
            :resource="platformResource"
            @change="onChange"
          />
        </v-col>
      </v-row>
      <div
        v-if="productTemplateType === 'Custom'"
      >
        <v-row>
          <v-col
            cols="12"
          >
            <base-resource-select
              :key="productTypeId"
              label="Product"
              item-text="product"
              item-value="id"
              bind-text="product"
              bind-value="productId"
              :bind-item="editedItem"
              :error-messages="safeFormErrors.ProductId"
              :fetch-method="getProducts"
              @change="onChange"
            />
          </v-col>
        </v-row>
        <v-row>
          <v-col
            cols="12"
          >
            <base-resource-select
              label="Carrier"
              item-text="carrier"
              item-value="id"
              bind-text="carrier"
              bind-value="carrierId"
              :bind-item="editedItem"
              :error-messages="safeFormErrors.CarrierId"
              :resource="carrierResource"
              @change="onChange"
            />
          </v-col>
        </v-row>
      </div>
    </div>
  </v-container>
</template>

<script>
  import TroodyApi from '@/services/troody/TroodyApi'

  export default {
    name: 'ProductTemplateEdit',

    props: {
      formErrors: {
        type: Object,
        default: null,
      },
      value: {
        type: Object,
        default: null,
      },
    },

    data: () => ({
      editedItem: null,

      productTypeId: 0,
      productTemplateTypeId: null,
      productTemplateType: null,

      productResource: new TroodyApi('product/'),
      carrierResource: new TroodyApi('carrier/'),
      platformResource: new TroodyApi('platform/'),
      productTypeResource: new TroodyApi('productType/'),
    }),

    computed: {
      safeFormErrors () {
        return this.formErrors || {}
      },
    },

    created () {
      this.initialize()
    },

    methods: {
      initialize () {
        this.editedItem = (this.value || {})
        this.productTypeId = this.editedItem.productTypeId || 0
      },

      setProductTemplate (selectedValue, fetchedItems) {
        this.productTemplateTypeId = null
        this.productTemplateType = null
        if (fetchedItems && fetchedItems.length) {
          for (let i = 0; i < fetchedItems.length; i++) {
            if (fetchedItems[i].id === selectedValue) {
              this.productTemplateTypeId = fetchedItems[i].productTemplateTypeId
              this.productTemplateType = fetchedItems[i].productTemplateType
              break
            }
          }

          if (this.productTemplateType === 'Standard') {
            delete this.editedItem.productId
            delete this.editedItem.carrierId
          }
        }
      },

      productTypePopulated (bindItem, selectedValue, fetchedItems) {
        this.setProductTemplate(selectedValue, fetchedItems)
      },

      productTypeChanged (bindItem, selectedValue, fetchedItems) {
        this.setProductTemplate(selectedValue, fetchedItems)
        this.productTypeId = selectedValue
        this.onChange()
      },

      onChange () {
        this.$emit('update:value', this.editedItem)
        this.$emit('change', this.editedItem, this.productTemplateType)
      },

      getProducts () {
        return this.productResource.query({ productTypeId: this.productTypeId })
      },

    },
  }
</script>
